import * as React from 'react'

import { get } from 'lodash'
import * as queryString from 'query-string'
import { renderRoutes } from 'react-router-config'

import MarketHeader from '@envato/market-shared-header'

import HeadBanner from '../components/banners/headBanner'
import CategoriesMenu from '../components/categoriesMenu'
import CrossSellLinksFooter from '../components/crossSellLinksFooter'
import SiteFooter from '../components/footer/siteFooter'
import LoadingSpinner from '../components/icons/loadingSpinner'
import Modal from '../components/modals/'
import PageOffLeftMenu from '../components/pageOffCanvasLeft/pageOffLeftMenu'
import PageOffLeftSearchBar from '../components/pageOffCanvasLeft/pageOffLeftSearchBar'
import SiteMeta from '../components/siteMeta/siteMeta'

import { reportModalPageView } from '../../common/analytics/userAnalytics'
import { config } from '../../common/config'
import { getCurrentSiteDomain } from '../../common/utils/sites'
import siteConfigs from '../../config/sites'
import OldIE from '../../server/template/oldIE'
import createNotFoundContainer from '../containers/notFoundContainer'
import NotFoundPage from './notFoundPage'
import SearchOfflinePage from './searchOfflinePage'

import { Props } from '../containers/appContainer'

import * as styles from './app.module.css'

const ssoServerHost = config.sso.SERVER_HOST

class App extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  public componentDidMount() {
    const fastclick = require('fastclick')
    const { initUser } = this.props

    fastclick.attach(document.body)

    // init user and load user preference
    initUser()
  }

  public render() {
    const {
      user,
      stats,
      currentSite,
      seoMeta,
      location,
      baseUrl,
      menuConfig,
      noIndex,
      isModalOpen,
      closeModal,
      openModalType,
      openModalData,
      banners,
      openModal,
      handleSignInSuccess,
      clientFinishedLoading,
      clientVersion
    } = this.props

    // add query back to location object
    // TODO: fetch from redux store instead of `withRouter`
    location.query = queryString.parse(location.search)

    const pageOffLeftMenu = <PageOffLeftMenu items={menuConfig} />
    const pageOffLeftSearchBar = <PageOffLeftSearchBar location={location} />

    const onClickSignIn = (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault()
      reportModalPageView({
        title: 'Modal: direct sign in',
        page: '//direct-sign-in'
      })
      openModal({
        type: 'signIn',
        payload: {
          currentSite,
          onSignInSuccess: handleSignInSuccess,
          welcomeMsg: 'Great to have you back!'
        }
      })
    }
    const headerConfigs = {
      ssoServerHost,
      rootDomain: `//${getCurrentSiteDomain(currentSite)}`
    }

    return (
      <div className="page">
        <OldIE siteName={currentSite} />
        <SiteMeta
          seoMeta={seoMeta}
          location={location}
          currentSite={currentSite}
          noIndex={noIndex}
          baseUrl={baseUrl}
        />

        <Modal
          closeModal={closeModal}
          isModalOpen={isModalOpen}
          openModalType={openModalType}
          openModalData={openModalData}
        />

        <div className="page__canvas">
          <div className="canvas">
            <div
              className={styles.headerWrapper}
              data-test-selector="global-header-wrapper"
            >
              <HeadBanner banners={banners} />
              <MarketHeader
                user={user}
                currentSite={currentSite}
                mobileCategoriesMenu={pageOffLeftMenu}
                mobileCategoriesSearchBar={pageOffLeftSearchBar}
                onClickSignIn={onClickSignIn}
                configs={headerConfigs}
              />

              <div className={styles.headerCategoriesWrapper}>
                <div className={styles.headerCategories}>
                  <div className={styles.gridWide}>
                    <CategoriesMenu items={menuConfig} />
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.contentSection}>
              {clientVersion === 2 &&
                !clientFinishedLoading &&
                this.renderLoadingCover()}
              {this.renderContent()}
            </div>

            <CrossSellLinksFooter currentSite={currentSite} />
            <SiteFooter stats={stats} usDollarsNotice={user.usDollarsNotice} />
          </div>
        </div>
      </div>
    )
  }

  private renderLoadingCover() {
    return [
      <style key="style">{`
          .js .loadingContainer {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 10000;
            background: rgba(255, 255, 255, 1);
            text-align: center;
            padding-top: 44px;
          }
      `}</style>,
      <div key="loadingContainer" className="loadingContainer">
        <LoadingSpinner />
      </div>
    ]
  }

  private renderContent() {
    const { errorPage, location, currentSite, route } = this.props

    // add query back to location object
    location.query = queryString.parse(location.search)

    const popularFilesUrl = `//${getCurrentSiteDomain(
      currentSite
    )}/page/top_sellers`
    const siteDisplayName =
      get(siteConfigs, `${currentSite}.name`) || currentSite
    const NotFoundContainer = createNotFoundContainer(NotFoundPage)

    if (route) {
      switch (errorPage) {
        case 'NotFoundContainer':
          return <NotFoundContainer location={location} />

        case 'SearchOffline':
          return (
            <SearchOfflinePage
              popularFilesUrl={popularFilesUrl}
              siteDisplayName={siteDisplayName}
            />
          )

        default:
          return renderRoutes(route.routes)
      }
    } else {
      return <NotFoundContainer location={location} />
    }
  }
}

export default App



// WEBPACK FOOTER //
// ./client/pages/app.tsx